import React from 'react';
import Asset from './asset';
import styles from './project-single.module.scss';
import theme from '../styles/theme.module.scss';

function Row(props) {
  const pT = props.row.noTopPadding ? '' : 'pT4';
  const pB = props.row.noBottomPadding ? '' : 'pB4';
  return (
    <div
      className={[styles.row, styles[props.type], theme[pT], theme[pB]].join(' ')}
      style={{ backgroundColor: `${props.bgColor}`, color: `${props.textColor}` }}>
      {props.row.asset.map((value, key) => {
        const gds = `gds${value.grid?.gridStart ?? 0}`;
        const gde = `gde${value.grid?.gridEnd ?? 13}`;
        const gms = value.gridMobile ? `gms${value.gridMobile.gridStart}` : `gms1`;
        const gme = value.gridMobile ? `gme${value.gridMobile.gridEnd}` : `gme4`;
        const maxWidth = (gde - gds) * 160;
        const overlay = `overlay_${value.overlay}`;
        const mobileClass = value.overlay === 'mobile' ? 'mobile_overlay-w' : '';

        return (
          <div className={[styles.assetWrapper, theme.gdcont, theme.gmcont].join(' ')} key={key}>
            <div
              className={[
                styles.asset,
                styles[overlay],
                theme[gds],
                theme[gde],
                theme[gms],
                theme[gme],
              ].join(' ')}>
              <Asset asset={value.asset[0]} maxWidth={maxWidth} mobileClass={mobileClass} />
              {value.caption && (
                <>
                  <p className={`${theme.h5_founders} ${theme.mT12}`}>{value.caption}</p>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Row;
